module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/entrance-ea5218c8a585959a61ffdb4e62419471.webp";